import { ContactObject } from "../types/contact";

export const contactObjectLabels = [
  { label: "Contenu scientifique", value: ContactObject.SCIENTIFIC_CONTENT },
  { label: "Question technique", value: ContactObject.TECHNICAL_QUESTION },
  { label: "Gestion abonnement", value: ContactObject.SUBSCRIPTION },
  { label: "Autre", value: ContactObject.OTHER },
];
